import z from "zod";

export enum AssignType {
  create = "create",
  assign = "assign",
}

export const serviceAccountFormSchema = z.object({
  name: z
    .string()
    .regex(/^[a-zA-Z0-9_]+$/, {
      error: "Use letters, numbers, underscore",
    })
    .min(3, { error: "Must be at least 3 characters long" })
    .max(64, { error: "Must be 64 or fewer characters long" }),
  description: z.string(),
  networkPolicyName: z.string().optional(),
  isAdmin: z.boolean(),
});

export type ServiceAccountFormFields = z.infer<typeof serviceAccountFormSchema>;

const fullSchema = serviceAccountFormSchema.extend({
  accountName: z.string(),
  assignType: z.enum(AssignType),
  userName: z.string().optional(),
  assign: z.record(z.string(), z.string(), {
    error: "User name is required",
  }),
});

const createUserSchema = z.object({
  assignType: z.literal(AssignType.create),
  defaultDatabase: z.string().optional(),
  defaultEngine: z.string().optional(),
  userName: z
    .string()
    .max(64, { error: "Must be 64 or fewer characters long" })
    .regex(/^[a-zA-Z0-9].*[a-zA-Z0-9]$/, {
      error: "The first and last characters must be a letter or a digit.",
    })
    .regex(/^[a-zA-Z0-9!#@$%&'*+\-=?^_`{|}~.]*$/, {
      error: "Use letters, numbers or ! # $ % & ' * + - = ? ^ _ ` { | } ~ .",
    }),
  roles: z.array(z.string()).optional(),
});

const assignUserSchema = z.object({
  assignType: z.literal(AssignType.assign),
  assign: z.record(z.string(), z.string(), {
    error: "User name is required",
  }),
});

const schemaConditions = z.discriminatedUnion("assignType", [
  createUserSchema,
  assignUserSchema,
]);

export const schema = z.intersection(schemaConditions, fullSchema);

export type Fields = z.infer<typeof schema>;

export const CREATE_NEW = "__create_new__";
